export default __webpack_public_path__ + "static/growingBussinessBg-cc7b939fe853a4cf8e0a3041c4f1009e.png";